window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-handwrite').forEach(handwrite => {
    Fancybox.bind(handwrite.querySelector('.product-handwrite-box'), {
      keyboard: true,
      buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'share', 'close']
    });
  });
});